/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import {useSelector} from 'react-redux';
import {CTCEntity} from '@ion/core/src/types/entities';

/**
 * Provides a utility hook for getting the add operation results for any entity via
 * its respective reducer ...
 *
 * ```typescript
 *
 *   import {useAddResults} from '@ion/dls/src/hooks/';
 *   const addResult = useAddResults('reducer');
 *
 * ```
 */
export const useAddResults = (reducer: string): CTCEntity | CTCEntity[] => {
  return useSelector(({[reducer]: {add}}) => add?.result);
};

export default useAddResults;
